import ListView from '../../../components/listView/ListView'
import Page from '../../../components/pageView/Page'
import WidgetPage from '../../../components/widgetPage/WidgetPage'
import StepView from '../../../components/stepView/StepView'

const routesProject = [
    {
        path: "/project",
        element: WidgetPage,
        props: { type: 'project', draggable: false, resizable: false }
    },
    {
        path: "/project/project",
        element: ListView,
        props: { type: 'projectList' }
    },
    {
        path: "/project/team",
        element: ListView,
        props: { type: 'projectTeamList' }
    },
    {
        path: "/project/team/:id",
        element: Page,
        props: {
            type: "projectTeamPage",
            options: { mode: 'view', load: true }
        }
    },
    {
        path: "/project/new",
        element: Page,
        props: {
            type: "projectCard",
            options: { mode: "new", load: false }
        }
    },
    {
        path: "/project/kanban",
        element: Page,
        props: {
            type: "taskKanbanView",
            options: { mode: "view", load: false }
        }
    },
    {
        path: "/project/project/:id",
        element: Page,
        props: {
            type: "projectTabPage",
            options: { mode: "edit", load: true, onMount: 'collapse' }
        }
    },
    {
        path: "/project/project/:id/createInvoice",
        element: StepView,
        props: { type: "projectInvoiceWizard" }
    },
    {
        path: "/project/project/:id/projectTask/new",
        element: Page,
        props: {
            type: "projectTaskPage",
            options: { mode: "new", load: false }
        }
    },
    {
        path: "/project/project/:id/projectTask/:id2",
        element: Page,
        props: {
            type: "projectTaskPage",
            options: { mode: "edit", load: true }
        }
    },
    {
        path: "/project/settings",
        element: Page,
        props: {
            type: "projectSettingsPage",
            options: { mode: "edit", load: true, onMount: 'collapse' }
        }
    }
]

export default routesProject
